<template>
  <div id="profile">
    <Navbar :data="0" />
    <div v-if="show" :style="{left: lang === 'ar' ? 'unset' : '0', right: lang === 'ar' ? '0' : 'unset' }" :class="[lang === 'ar' ? 'left-dir' : 'right-dir', 'blur-background']">
      <profile-extra-data-card @close="closeCard" :gsm="gsm"  :cardType="cardType" :show="show" />
    </div>
    <hotline-loss :isActive="Number(0)" v-if="$store.state.activateHotLine === true"></hotline-loss>
    <hotline-loss :isActive="Number(1)" v-if="$store.state.deactivateHotLine === true"></hotline-loss>
    <div :class="[lang === 'ar' ? 'right-dir' : 'left-dir', 'content']">
      <div class="personal-data">
        <!-- personal header -->
        <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en', 'header']">
<!--          <div class="greet">{{ $t('profile.greet') }}</div>-->
          <div @click="showCard({ gsm: '', type: 'personal-card' })" class="profile-data">
            <span class="name">{{ userName }}</span>
            <span class="personal-dialog-btn">{{ $t('profile.userProfile') }}</span>
          </div>
        </div>
        <!-- --------------------------------- -->
        <!-- data -->
        <div class="scroll-it">
          <div :class="['numbers-data']">
            <div class="number-list mb-4">
              <span :class="[lang === 'ar' ? 'bold-ar' : 'bold-en', 'titles mx-2']">{{ $t('profile.numbersData.title') }}</span>
              <span :class="lang === 'ar' ? 'regular-ar' : 'regular-en'">( {{ fetched ?  numbers.length : 0 }} {{ $t('profile.numbersData.info') }})</span>
            </div>
            <div :key="componentKey" class="swiper mySwiper">
              <div  class="swiper-wrapper">
                <div v-for="(card, i) in numbers" :key="i" class="swiper-slide">
                  <div class="card-container">
                    <profile-card @refresh="refresh" :error="error" :empty="empty" :fetched="fetched" :active="activeCard" :number="i" @clicked="showCard" :data="card" />
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <button @click="addNewNumber" :class="[lang === 'ar' ? 'bold-ar flex-row-reverse' : 'bold-en', 'add-btn mb-5']">
            {{ $t('profile.addBtn')}}
            <span :class="[lang === 'ar' ? 'regular-ar' : 'regular-en' ,'mx-3']"> + </span>
          </button>
        </div>
        <!-- ---------------------------------- -->
      </div>
      <!---------------------------------------- routed sections --------------------------------->
      <div :style="{ opacity: show ? '50%' : '100%', pointerEvents: show ? 'none' : 'unset' }" class="routed-sections">
        <v-tabs v-model="tab">
          <v-tab v-for="(tab, i) in components" :key="i">
            <span :class="lang === 'ar' ? 'bold-ar' : 'bold-en'"> {{ tab.title }} </span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" :touchless="true">
          <div class="tabs-content">
            <v-tab-item v-for="(component, i) in components" :key="i">
              <div class="routed-section">
                <component :is="component.comp"></component>
              </div>
            </v-tab-item>
          </div>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>
<script>
import ActiveBundles from './components/ActiveBundles'
import FeatureController from './components/FeatureController'
import ProfileCard from '../../components/cards/ProfileCard'
import ProfileExtraDataCard from '../../components/cards/ProfileExtraDataCard'
import UserNameRepository from '../../repositories/UserNameRepository'
import AddNewItemRepository from '../../repositories/AddNewItemRepository'
import Services from './components/Services'
import { Swiper } from 'swiper/swiper-bundle'
import 'swiper/swiper-bundle.css'
import 'swiper/modules/effect-cards.min.mjs'
import 'swiper/modules/effect-cards.css'
import Navbar from '../Navbar'
import UserNumbersRepository from '../../repositories/UserNumbersRepository'
import NumberIndoRepository from '../../repositories/NumberIndoRepository'
import hotlineLoss from '../../components/feature-controller/hotlineLoss'
export default {
  components: { ProfileExtraDataCard, Navbar, ActiveBundles, Services, FeatureController, ProfileCard, Swiper, hotlineLoss },
  data () {
    return {
      userNameRepo: new UserNameRepository(),
      show: false,
      cardType: '',
      userName: '',
      gsm: localStorage.getItem('selectedNum'),
      lang: this.$lang,
      tab: null,
      userNumbersRepo: new UserNumbersRepository(),
      numberInfoRepo: new NumberIndoRepository(),
      components: [{ title: this.$t('profile.tabs[0]'), comp: 'ActiveBundles' }, { title: this.$t('profile.tabs[1]'), comp: 'FeatureController' }, { title: this.$t('profile.tabs[2]'), comp: 'Services' }],
      numbers: [{}],
      addItemRepo: new AddNewItemRepository(),
      fetched: false,
      error: false,
      empty: false,
      window: this.$store.state.window,
      componentKey: 0,
      swiper: null,
      activeCard: 0,
      allFetched: false
    }
  },
  created () {
    this.$store.state.activeSectionNav = null
  },
  mounted () {
    this.$watch(() => {
      return this.$store.state.selectedNumber // the selected number by user from welcome menu
    }, val => {
      this.$store.state.passedNum = val // if the user select a number then the displayed data will be related to this number
      this.destroySwiper() // we should destroy the swiper and rebuild it to make the selected number card at the top of the cards
      this.refresh()
    })
    // this.$store.state.passedNum = this.gsm // at the first load this value which will be passed to the active bundle section and services and feature controller and render the data based on this number
    this.$store.state.passedNum = this.$store.state.selectedNumber // at the first load this value which will be passed to the active bundle section and services and feature controller and render the data based on this number
    this.$watch(() => {
      return this.$store.state.isAdded // if a new number added to the list of numbers destroy the swiper and rebuild it
    }, val => {
      this.$store.state.passedNum = this.$store.state.selectedNumber
      this.destroySwiper()
      this.refresh()
    })
    setTimeout(() => {
      this.fetchNumbers() // fetch the numbers list that related to this number
      this.getUser() // get the user name of the number that the user logged in using it
    })
    this.$watch(() => {
      return this.$store.state.activeCard // change every time the swiper top card change
    }, val => {
      this.$store.state.passedNum = this.numbers[val].gsm
      this.$store.state.passedLineType = this.numbers[val].data.lineType
    })
    this.$watch(() => {
      return this.$store.state.forbidden
    }, (val) => {
      this.refresh()
      this.$store.state.passedNum = this.$store.state.mainGsm
    })
  },
  watch: {
    tab (val) {
      this.$store.state.profileTab = val
    }
  },
  methods: {
    refresh () {
      this.destroySwiper()
      this.numbers = [{}]
      this.error = false
      this.fetched = false
      this.empty = false
      this.fetchNumbers()
      this.getUser()
    },
    async getUser () {
      try {
        const formData = new FormData()
        const gsm = this.$store.state.selectedNumber
        formData.append('gsm', gsm)
        const response = await this.userNameRepo.post(formData)
        if (response.status === 200) {
          this.userName = response.data.data.name
        }
      } catch (e) {
        console.log(e)
      }
    },
    showCard (obj) {
      this.cardType = obj.type
      this.gsm = obj.gsm
      this.show = true
    },
    closeCard () {
      this.cardType = ''
      this.show = false
    },
    createSwiper () {
      // console.log('create swiper')
      const temp = this
      this.swiper = new Swiper('.mySwiper', {
        effect: temp.$store.state.window > 480 ? 'cards' : 'flip',
        grabCursor: true,
        loop: false,
        rotate: true,
        pagination: {
          el: '.swiper-pagination'
        },
        cardsEffect: {
          perSlideOffset: 8, // Space between cards in px
          perSlideRotate: 4
        },
        on: {
          slideChange: function (swiper) {
            if (temp.allFetched) {
              temp.$store.state.activeCard = swiper.activeIndex
            }
          }
        }
      })
    },
    destroySwiper () {
      this.swiper.destroy(false, true)
    },
    // async fetchNumbers () {
    //   try {
    //     const response = await this.userNumbersRepo.get()
    //     if (response.status === 200) {
    //       if (response.data.length) {
    //         this.numbers = []
    //         let index
    //         let temp
    //         for (let i = 0; i < response.data.length; i++) {
    //           if (response.data[i].gsm === this.$store.state.selectedNumber) {
    //             index = i
    //             temp = response.data[i]
    //           }
    //           if (response.data[i].isMain === 1) {
    //             this.$store.state.mainGsm = response.data[i].gsm
    //           }
    //           this.numbers.push(response.data[i])
    //         }
    //         this.numbers.splice(index, 1) // remove the selected number from this array
    //         this.numbers.unshift(temp) // insert the selected number in the first index of the array
    //         this.createSwiper()
    //         await this.fetchNumberDetails()
    //         this.allFetched = true
    //       } else {
    //         this.empty = true
    //       }
    //     }
    //   } catch (e) {
    //     // this.error = true
    //     console.log(e)
    //   }
    // }
    async fetchNumbers () {
      try {
        const response = await this.userNumbersRepo.get()
        if (response.status === 200) {
          if (response.data.length) {
            // FILTER: Only keep numbers that start with "09"
            const filteredNumbers = response.data.filter(item => item.gsm.startsWith('09'))

            if (filteredNumbers.length === 0) {
              // No valid numbers found
              this.empty = true
              this.fetched = true
              this.numbers = []
              return
            }

            this.numbers = []
            let index
            let temp

            // Process only the filtered numbers
            for (let i = 0; i < filteredNumbers.length; i++) {
              if (filteredNumbers[i].gsm === this.$store.state.selectedNumber) {
                index = i
                temp = filteredNumbers[i]
              }
              if (filteredNumbers[i].isMain === 1) {
                this.$store.state.mainGsm = filteredNumbers[i].gsm
              }
              this.numbers.push(filteredNumbers[i])
            }

            // Reorder: put selected number at the front
            if (temp) {
              this.numbers.splice(index, 1)
              this.numbers.unshift(temp)
            }

            this.createSwiper()
            await this.fetchNumberDetails()
            this.allFetched = true
          } else {
            this.empty = true
          }
        }
      } catch (e) {
        this.error = true
        console.log(e)
      }
    },
    async fetchNumberDetails () {
      try {
        for (let i = 0; i < this.numbers.length; i++) {
          const formData = new FormData()
          formData.append('gsm', this.numbers[i].gsm)
          const response = await this.numberInfoRepo.post(formData)
          this.numbers[i] = { ...this.numbers[i], data: response.data.data }
          if (this.numbers[this.numbers.length - 1].data) {
            this.fetched = true
          }
        }
        this.$forceUpdate()
      } catch (e) {
        this.error = true
        console.log(e)
      }
    },
    async addNewNumber () {
      this.$store.state.addNewNumber = true
      this.$store.state.registerDialog = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";
#profile {
  height: 100vh;
}
.blur-background {
  text-align: initial;
  background: rgba(0,0,0,0.2);
  backdrop-filter: blur(15px);
  height: 100%;
  width: 38%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
}
.content {
  text-align: initial;
  min-height: 100%;
  height: fit-content;
  width: 100%;
  background-color: rgba(242,242,242);
  background-image: url("../../assets/images/double-circle.svg");
  background-size: cover;
  padding-top: 110px;
  display: flex;
}
/*----------------------------------------------------- personal section ----------------- */
.personal-data {
  width: 38%;
  background: linear-gradient(230deg, rgba(242, 242, 242, 0.45), rgba(255,255,255, 0.45));
  backdrop-filter: blur(15px); //20 in design
  box-shadow: 10px 10px 30px rgba(0,0,0,0.3);
  border: 3px solid #FFFFFF;
  border-top: none;
}
.header {
  height: 90px;
  width: 98%;
  margin: 0 auto;
  border-bottom: 3px solid #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 1rem 8px 2rem;
}
.scroll-it {
  height: calc(100vh - (110px + 90px));
  overflow-y: auto;
  overflow-x: hidden;
}
.profile-data {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.greet {
  color: #1d1d1d;
  font-size: 19.5px;
}
.name {
  color: $--yellow;
  font-size: 23px;
  margin-bottom: -5px
}
.personal-dialog-btn {
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
.numbers-data {
  padding: 2rem 0 1rem 0
}
.number-list {
  padding: 0 2.2rem;
}
.add-btn{
  width: 85%;
  height: 64px;
  background: $--yellow;
  margin: 0 auto;
  border-radius: 25px;
  border: 2.5px solid rgba(255,255,255,0.9);
  box-shadow: 10px 10px 30px rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.add-btn > span {
  font-size: 28px
}
.add-btn:focus {
  outline: none;
}
/*------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------- routed sections --------------------------------------------*/
.routed-sections {
  width: calc(100% - 38%);
  background: linear-gradient(135deg, rgba(242,242,242, 0.5), rgba(255,255,255, 0.5));
  backdrop-filter: blur(30px); //30
}
/*----------------------------------------------------------------------------------------------------------------*/
/*------------------------------------------------- responsive -----------------------------------------------------*/
@media (max-width: 1400px) {
  .routed-sections {
    width: calc(100% - 40%);
  }
  .blur-background,
  .personal-data {
    width: 40%
  }
  .swiper-cards {
    width: 85%;
    max-width: 500px
  }
}
@media (max-width: 1265px) {
  .scroll-it {
    height: auto;
  }
  #profile {
    height: 100vh;
    overflow-y: auto;
  }
  .content {
    display: block;
  }
  .personal-data,
  .routed-sections,
  .blur-background {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .header {
    padding: 0.4rem 0.5rem;
    min-height: 90px;
    height: unset;
  }
}
/*---------------------------------------------------------------------------------------------------------------------*/
</style>
<style lang="scss">
@import "src/assets/sass/main";
#profile {
  .v-tabs,
  .v-item-group.theme--light.v-slide-group.v-tabs-bar.primary--text{
    height: 90px;
  }
  .v-tabs {
    background:  linear-gradient(180deg, rgba(242,242,242, .8), rgba(255,255,255, .8)); //0.6 in design
    backdrop-filter: blur(25px);
  }
  .v-window.v-item-group.theme--light.v-tabs-items,
  .v-window-item{
    //height: 100% !important;
    //min-height: 100% !important;
  }
  .v-item-group {
    background: transparent;
  }
  .v-slide-group__wrapper{
    height: 100%;
    width: 100%
  }
  .v-tab {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 10px;
    max-width: none;
    font-size: 14px;
    text-transform: none;
    color: $--yellow;
    border-bottom: 2px solid #FFFFFF;
    letter-spacing: normal;
  }
  .v-slide-group__content.v-tabs-bar__content{
    color: $--yellow
  }
  .v-slide-group__prev,
  .v-slide-group__next{
    display: none
  }
  .v-tab {
    padding: 0 5px 5px 0;
  }
  /*----------------- swiper -----------------*/
  .swiper {
    width: 90%;
    overflow: unset
  }
  .swiper-cards{
    width: 80%
  }
  .swiper-slide-shadow.swiper-slide-shadow-cards {
    background: none !important;
  }
  .swiper-cards .swiper-slide{
    overflow: unset !important;
  }
  .swiper-pagination{
    margin-top: 2rem;
    position: unset !important;
  }
  .swiper-pagination-bullet{
    background: rgba(0,0,0,0.2) !important;
    margin: 0 1rem;
    width: 6px;
    height: 6px
  }
  span.swiper-pagination-bullet {
    opacity: 1 !important;
  }
  .swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal.swiper-pagination-lock {
    display: block;
  }
  span.swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: rgba(0,0,0,1) !important;
    display: inline-block !important;
  }
  /*-------------------------------------------*/
  /*---------------- responsive --------------------*/
  @media (max-width: 570px) {
    .swiper-cards {
      width: 90% !important;
    }
  }
  @media (max-width: 480px) {
    .v-tabs,
    .v-item-group.theme--light.v-slide-group.v-tabs-bar.primary--text{
      height: 70px;
    }
  }
  /*-------------------------------------------------*/
}
</style>
